var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLicense24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contract",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25092",
    "data-name": "Group 25092",
    transform: "translate(0 11.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46123",
    "data-name": "Path 46123",
    d: "M39.8,423.247V422H31.4a.405.405,0,0,0-.4.41,2.028,2.028,0,0,0,2,2.051h7.193A2.057,2.057,0,0,1,39.8,423.247Z",
    transform: "translate(-31 -422)",
    fill: "#999"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25093",
    "data-name": "Group 25093",
    transform: "translate(1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46124",
    "data-name": "Path 46124",
    d: "M94.6,7.437a.41.41,0,1,0,.4.41A.406.406,0,0,0,94.6,7.437Zm0,0a.41.41,0,1,0,.4.41A.406.406,0,0,0,94.6,7.437ZM101,0H91.4a.405.405,0,0,0-.4.41V10.719h7.6a.405.405,0,0,1,.4.41v1.658a1.2,1.2,0,1,0,2.4,0V.41A.405.405,0,0,0,101,0ZM96.483,9.778a.393.393,0,0,1-.566,0l-.8-.821a1.171,1.171,0,0,1-1.034,0l-.8.821a.394.394,0,0,1-.566,0,.418.418,0,0,1,0-.58l.8-.82a1.247,1.247,0,0,1-.117-.53,1.2,1.2,0,1,1,2.4,0,1.247,1.247,0,0,1-.117.53l.8.82a.418.418,0,0,1,0,.58Zm-.283-4.8H93.8a.41.41,0,0,1,0-.82h2.4a.41.41,0,0,1,0,.82Zm2.4-1.641H93.8a.41.41,0,0,1,0-.82h4.8a.41.41,0,0,1,0,.82Zm-4,4.1a.41.41,0,1,0,.4.41A.406.406,0,0,0,94.6,7.437Zm0,0a.41.41,0,1,0,.4.41A.406.406,0,0,0,94.6,7.437Zm0,0a.41.41,0,1,0,.4.41A.406.406,0,0,0,94.6,7.437Z",
    transform: "translate(-91)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLicense24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_license24x24.a279bb123d85ea92135cc3e383a24528.svg";